/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  if ( !Cookies.get('quick-cta-widget') )  {

    Cookies.set('quick-cta-widget', {
      dismissWidget : false
    }, {
      expires : 7,
      path    : '/',
    });

  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var Sage = {
    'widgetDismiss' : false,
    'currentDomain' : document.location.origin, 

    // All pages
    'common': {

      init: function() {

        $('[data-fancybox]').fancybox({
          toolbar  : false,
          smallBtn : true,
          iframe : {
            preload : false
          }
        });

        if ( $("#brandsModal").length > 0) {

          $('#brandsModal').on('show.bs.modal', function (event) {
            var button = $(event.relatedTarget);
            var brandEl = button.data('brand');
            var modal = $(this);
            console.log($(brandEl).html());
            modal.find('.modal-content').html( $(brandEl).html() );
          });

        }

        /*
        toastr.options = {
          "closeButton"       : true,
          "debug"             : false,
          "newestOnTop"       : false,
          "progressBar"       : true,
          "positionClass"     : "toast-bottom-right",
          "preventDuplicates" : true,
          "showDuration"      : "300",
          "hideDuration"      : "1000",
          "timeOut"           : "10000", // How long the toast will display without user interaction
          "extendedTimeOut"   : "10000", // How long the toast will display after a user hovers over it
          "showEasing"        : "swing",
          "hideEasing"        : "linear",
          "showMethod"        : "fadeIn",
          "hideMethod"        : "fadeOut",
          "closeMethod"       : "fadeOut",
          "tapToDismiss"      : false
        };

        var widgetCookie    = Cookies.getJSON('quick-cta-widget');
        Sage.widgetDismiss  = widgetCookie.dismissWidget;

        $(window).scroll(function() {
          if($(window).scrollTop() + $(window).height() === $(document).height()) {

            if ( false === Sage.widgetDismiss && ( $('.home').length <= 0 ) ) {

              toastr.info('' +
              '<div class="quick-cta-widget">' +
                '<h3>Contact Us</h3>' + 
                '<p><a href="tel:19096253700">(909) 625-3700</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="mailto:customerservice@Quickdispense.com"><i class="fa fa-envelope-o" aria-hidden="true"></i> EMAIL</a></p>' + 
                '<hr />' + 
                '<h3>Free Demo Kit</h3>' + 
                '<p>Have a coffee on us! Get your demo kit and schedule your party now.<br /><div class="learn-more"><a href="/contact-us/">LEARN MORE</a></div></p>' + 
                '<hr />' + 
                '<h3>Product Search</h3>' + 
                '<p>' +
                  '<form role="search" method="get" class="search-form" action="' + Sage.currentDomain + '">' +
                    '<label>' +
                      '<span class="screen-reader-text">Search for:</span>' +
                      '<input type="search" class="search-field" placeholder="Search …" value="" name="s">' +
                    '</label>' +
                    '<input type="submit" class="search-submit" value="Search">' +
                  '</form>' +
                '</p>' + 
                '<hr />' + 
                '<h3>Special of the Month</h3>' + 
                '<p>Get limited offers and instant savings.<div class="learn-more"><a href="/monthly-special/">LEARN MORE</a></div></p>' + 
                '' + 
              '</div>');

            }

          }
        });

        toastr.options.onCloseClick = function() {

          Sage.widgetDismiss = true;
          Cookies.set('quick-cta-widget', {
            dismissWidget : true
          }, {
            expires : 7,
            path    : '/',
          });

        };

        */

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }

    },

    // Home page
    'home': {

      arLayout: function() {

        var layout, winW, winH, videoAR, windowAR;

        winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        winH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        videoAR  = 596/336; // 1.77
        windowAR = winW / winH; // dynamic

        if ( windowAR > videoAR ) {
          layout = 'horizontal';
        } else {
          layout = 'vertical';
        }

        return layout;

      },

      init: function() {

        var layout;
        layout = this.arLayout();

        $("#introVideo").addClass(layout);

        window.onresize = function(event) {
          layout = Sage.home.arLayout();
          $("#introVideo").removeClass('horizontal');
          $("#introVideo").removeClass('vertical');
          $("#introVideo").addClass(layout);
        };
        
        /*
        $(".fancybox").fancybox({
          maxWidth  : 1024,
          fitToView : true,
          autoSize  : false,
          closeClick  : true,
          openEffect  : 'elastic',
          closeEffect : 'elastic',
          helpers:
          {
            overlay: {
              css: { 'background': 'rgba(0, 0, 0, 0.5)' }
            }
          }
        });
        */

      },
      
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }

    },

    'food_service': {

      init: function() {

        var $gallery = $('.ocs-carousel').flickity({
          cellSelector    : '.gallery-cell',
          imagesLoaded    : true,
          percentPosition : false,
          cellAlign       : 'center', 
          contain         : true,
          wrapAround      : true,
          autoPlay        : true
        });

      }

    },

    'office_coffee': {

      init: function() {

        var $gallery = $('.ocs-carousel').flickity({
          cellSelector    : '.gallery-cell',
          imagesLoaded    : true,
          percentPosition : false,
          cellAlign       : 'center', 
          contain         : true,
          wrapAround      : true,
          autoPlay        : true
        });

      }

    },

    // About us page, note the change from about-us to about_us.
    'about_us': {

      init: function() {
        // JavaScript to be fired on the about us page
      }
      
    }

  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
